import type { AdjustmentLineValues } from './adjustment-note-schema';

// `String(index)` is just there to satisfy `restrict-template-expressions`;
// the outer cast keeps the `${number}` literal in the RHF path type.
export function lineFieldPath<F extends keyof AdjustmentLineValues>(
  index: number,
  name: F,
): `adjustment_lines.${number}.${F}` {
  return `adjustment_lines.${String(index)}.${name}` as `adjustment_lines.${number}.${F}`;
}
